import React from 'react';
import useInView from './useInView';

const Reveal = ({ as: Comp = 'div', className = '', children, delayMs = 0 }) => {
  const { ref, inView } = useInView();
  return (
    <Comp
      ref={ref}
      className={`reveal ${inView ? 'is-inview' : ''} ${className}`}
      style={delayMs ? { transitionDelay: `${delayMs}ms` } : undefined}
    >
      {children}
    </Comp>
  );
};

export default Reveal;

